import { useState } from 'react';
import './MenuDrawer.scss';
import logo from "/app-logo.png";
import { Button, Typography } from "antd";
import { RANKINGS_APP_BASEURL, TEAM_MANAGER_APP_BASEURL } from "~shared/constants.ts";
import { Link } from "react-router-dom";
import { FormattedMessage } from "react-intl";

interface RightDrawerProps {
}

export const MenuDrawer = ({}: RightDrawerProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = () => {
    setIsOpen(!isOpen);
  };

  const productItems = [
    {
      key: "competition-admin-menu-item",
      href: "/",
      label: (
          <Typography.Text style={{ fontSize: "20px", fontFamily: "Roboto,sans-serif" }} strong>
            Competition Admin
          </Typography.Text>
      ),
      icon: <i style={{ color: "#ff0000", fontSize: "1.5rem" }} className="multi-color-icon-competition"/>,
    },
    {
      key: "rankings-menu-item",
      href: RANKINGS_APP_BASEURL,
      label: (
          <Typography.Text style={{ fontSize: "20px", fontFamily: "Roboto,sans-serif" }} strong>
            Rankings
          </Typography.Text>
      ),
      icon: <i style={{ color: "#00003C", fontSize: "1.5rem" }} className="fa-solid fa-star"/>,
    },
    {
      key: "team-manger-menu-item",
      href: TEAM_MANAGER_APP_BASEURL,
      label: (
          <Typography.Text style={{ fontSize: "20px", fontFamily: "Roboto,sans-serif" }} strong>
            Team Manager
          </Typography.Text>
      ),
      icon: <i style={{ color: "#00003C", fontSize: '1.5rem' }} className="fa-solid fa-users"/>,
    },
  ]

  return (
    <div className={`drawer-wrapper ${isOpen ? 'open' : 'closed'}`}>
      <div className={`drawer-content header-content ${isOpen ? 'open' : 'closed'}`}>
        <div className="menu-button">
          <Button
            type="text"
            size="large"
            icon={isOpen ? <i className="fa-solid fa-xmark"/> : <i className="fa-solid fa-bars"/>}
            onClick={toggleDrawer}
          />
        </div>
        <div className="drawer-app-logo">
          <div className="app-logo">
            <Link to="/">
              <img src={logo} alt="Logo" />
            </Link>
            <div className="logo-text">
              <FormattedMessage id="menu.available.modules"/>
            </div>
          </div>
        </div>
      </div>
      <div className="drawer-body">
        <div className="drawer-content body-content">
          {productItems.map((item) => (
            <Typography.Link href={item.href} className="product-item" key={item.key}>
              <div className="product-item-icon">{item.icon}</div>
              <div className="product-item-text">{item.label}</div>
            </Typography.Link>
          ))}
        </div>
      </div>
    </div>
  )
};